import React, { useState, useEffect } from "react";
import "../CSS/Style.css";
import axios from "axios";
import Header from "./Header";
import Pagination from "./Pagination";

const Charges = () => {
  const [token, setToken] = useState("");
  const [services, setServices] = useState([]);
  const [service, setService] = useState({ service_name: "", service_charge: "" });
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    const storedToken = sessionStorage.getItem("token");
    if (!storedToken) {
      window.location.href = "/signin";
    } else {
      setToken(storedToken);
      validateToken(storedToken);
      fetchServices(storedToken);
    }
  }, []);

  const validateToken = async (storedToken) => {
    try {
      const config = { headers: { Authorization: `Bearer ${storedToken}` } };
      const res = await axios.get("https://api.mahirefrigeration.com/api/validateToken", config);
      if (res.data === "User validation failed") {
        sessionStorage.clear();
        window.location.href = "/signin";
      }
    } catch (error) {
      console.error("Token validation error", error);
    }
  };

  const fetchServices = async (storedToken) => {
    setLoading(true);
    try {
      const config = { headers: { Authorization: `Bearer ${storedToken}` } };
      const response = await axios.get("https://api.mahirefrigeration.com/api/get_all_services", config);
      if (response.data.success) {
        setServices(response.data.services);
      } else {
        setMessage(response.data.message);
      }
    } catch (error) {
      setMessage("Failed to fetch services.");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setService({ ...service, [e.target.name]: e.target.value });
  };

  const addService = async (e) => {
    e.preventDefault();

    if (!service.service_name || !service.service_charge || isNaN(service.service_charge)) {
      setMessage("Service name and valid charge are required.");
      return;
    }

    const config = { headers: { Authorization: `Bearer ${token}` } };
    try {
      const res = await axios.post(
        "https://api.mahirefrigeration.com/api/add_service_charge",
        service,
        config
      );
      setMessage(res.data.message);

      if (res.data.success) {
        setService({ service_name: "", service_charge: "" });
        fetchServices(token);
      }
    } catch (err) {
      setMessage("Error adding service. Try again.");
    }
  };

  const indexOfLastService = currentPage * rowsPerPage;
  const indexOfFirstService = indexOfLastService - rowsPerPage;
  const currentServices = services.slice(indexOfFirstService, indexOfLastService);

  return (
    <>
      <Header />
      <div className="first_sec_ran">
        <div className="container">
        <div className="row my-4" style={{  }}>
          <div className="col-md-6 mt-4">
            <div className="container">
              <form onSubmit={addService}>
                <div className="parent" style={{ position: "relative", height: "" }}>
                <div className="box" style={{ width:"100%",flex: "2", padding: "20px", background: "#fff", borderRadius: "8px", boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",height:"470px",overflow:"auto"}}>

                    <h2 style={{ color: "skyblue" }}>Add Services and Charges</h2>

                    <div className="form__group field">
                    <label htmlFor="service_name" className="form__label">
                        Service Name
                      </label>
                      <input
                        type="text"
                        className="form__field"
                        placeholder="Service Name"
                        name="service_name"
                        value={service.service_name}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="form__group field">
                    <label htmlFor="service_charge" className="form__label">
                        Charge
                      </label>
                      <input
                        type="number"
                        className="form__field"
                        placeholder="Charge"
                        name="service_charge"
                        value={service.service_charge}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <br/>
                    <button
                      type="submit"
                      className="btn"
                      style={{
                        minWidth: "50%",
                        border: "1px solid skyblue",
                      }}
                    >
                      Add Service
                    </button>
                      <br/>
                    {message && <p className="message">{message}</p>}
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div className="col-md-6 mt-4">
            <div className="container">
              <div className="parent" style={{ position: "relative", height: "" }}>
              <div className="box" style={{ width:"100%",flex: "2", padding: "20px", background: "#fff", borderRadius: "8px", boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",height:"470px",overflow:"auto"}}>

                  {/* <div
                    className="box"
                    style={{
                      padding: "20px",
                      width: "100%",
                      background: "#fff",
                      borderRadius: "8px",
                      boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                    }}
                  > */}
                    <h2 style={{ color: "skyblue" }}>All Services</h2>
                    {loading ? <p>Loading...</p> : message && <p>{message}</p>}
                    {services.length > 0 ? (
                      <div className="table-wrapper" style={{ overflowX: "scroll", minWidth: "100%" }}>
                        <table className="table">
                          <thead>
                            <tr>
                              <th>Service Name</th>
                              <th>Charge</th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentServices.map((service, index) => (
                              <tr key={index}>
                                <td>{service.service_name}</td>
                                <td>{service.service_charge}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <p>No services found</p>
                    )}

                    {/* <div className="pagination">
                      {[...Array(Math.ceil(services.length / rowsPerPage)).keys()].map((number) => (
                        <button
                          key={number + 1}
                          onClick={() => setCurrentPage(number + 1)}
                          className={currentPage === number + 1 ? "active" : ""}
                        >
                          {number + 1}
                        </button>
                      ))}
                    </div> */}
                    <Pagination
                      currentPage={currentPage}
                      totalItems={services.length}
                      itemsPerPage={rowsPerPage}
                      onPageChange={setCurrentPage}
                     />

                  {/* </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </>
  );
};

export default Charges;
